// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_oq-8";
export var editMode = "_oq-3";
export var headerRow = "_oq-a";
export var headerTitle = "_oq-b";
export var product = "_oq-1";
export var productDetails = "_oq-5";
export var productDivider = "_oq-7";
export var productImage = "_oq-2";
export var productInfo = "_oq-4";
export var productTitle = "_oq-6";
export var strikethrough = "_oq-9";
export var upsellProductsCard = "_oq-0";